import React from "react";

export function ScoreBadge({ score = 0, size = "md", testid }) {
  const s = Math.max(0, Math.min(100, score));
  let tier = "cold";
  let cls = "border-zinc-700 text-zinc-400 bg-zinc-900";
  if (s >= 70) {
    tier = "hot";
    cls = "border-orange-500 text-orange-300 bg-orange-500/10 shadow-[0_0_12px_rgba(234,88,12,0.25)]";
  } else if (s >= 40) {
    tier = "warm";
    cls = "border-amber-500/60 text-amber-300 bg-amber-500/10";
  }
  const sizeCls = size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-1";
  return (
    <span
      data-testid={testid}
      data-tier={tier}
      className={`inline-flex items-center gap-1 rounded-sm border font-mono ${sizeCls} ${cls}`}
      title={`${s}/100 · ${tier.toUpperCase()}`}
    >
      <span className="opacity-60">SCORE</span>
      <span className="font-semibold">{s}</span>
    </span>
  );
}
